export const LOADER_STATUS = "boilerplate/NewEinv/Einvoice/LOADER_STATUS";
export const TABLE_DATA = "boilerplate/NewEinv/Einvoice/TABLE_DATA";
export const SEARCH_STR = "boilerplate/NewEinv/Einvoice/SEARCH_STR";
export const TOTAL_PAGES = "boilerplate/NewEinv/EinvoiceTOTAL_PAGES";
export const TOTAL_RECORDS = "boilerplate/NewEinv/Einvoice/TOTAL_RECORDS";
export const SELECTED = "boilerplate/NewEinv/Einvoice/SELECTED";
export const ITEM_LIST_DATA = "boilerplate/NewEinv/Einvoice/ITEM_LIST_DATA";
export const EINV_ITEM_ERROR_DATA =
  "boilerplate/NewEinv/Einvoice/EINV_ITEM_ERROR_DATA";
export const GST_RES_TABLE_DATA =
  "boilerplate/NewEinv/Einvoice/GST_RES_TABLE_DATA";
export const CHECKED_IRN = "boilerplate/NewEinv/Einvoice/CHECKED_IRN";
export const CHECKED_IRN_PAYLOAD =
  "boilerplate/NewEinv/Einvoice/CHECKED_IRN_PAYLOAD";
export const CHECKED_CANCEL = "boilerplate/NewEinv/Einvoice/CHECKED_CANCEL";
export const CHECKED_CANCEL_PAYLOAD =
  "boilerplate/NewEinv/Einvoice/CHECKED_CANCEL_PAYLOAD";
export const PROFILE_DATA = "boilerplate/NewEinv/Einvoice/PROFILE_DATA";
export const SELECTED_GSTIN = "boilerplate/NewEinv/Einvoice/SELECTED_GSTIN";
export const STATUS_CODE = "boilerplate/NewEinv/Einvoice/STATUS_CODE";
export const STATUS_CODE_CANCEL =
  "boilerplate/NewEinv/Einvoice/STATUS_CODE_CANCEL";
export const PART_B_ERROR = "boilerplate/NewEinv/Einvoice/PART_B_ERROR";
export const SUPPLIER_GSTIN_FILTER =
  "boilerplate/NewEinv/Einvoice/SUPPLIER_GSTIN_FILTER";
export const RECEIPIENT_GSTIN_FILTER =
  "boilerplate/NewEinv/Einvoice/RECEIPIENT_GSTIN_FILTER";
export const SELECTED_FROM_DATE =
  "boilerplate/NewEinv/Einvoice/SELECTED_FROM_DATE";
export const SELECTED_TO_DATE = "boilerplate/NewEinv/Einvoice/SELECTED_TO_DATE";
export const CHECKED_IRN_NOT_GENERATED =
  "boilerplate/NewEinv/Einvoice/CHECKED_IRN_NOT_GENERATED";
export const CHECKED_IRN_NOT_GENERATED_PAYLOAD =
  "boilerplate/NewEinv/Einvoice/CHECKED_IRN_NOT_GENERATED_PAYLOAD";
export const STATUS_CODE_NOT_GEN =
  "boilerplate/NewEinv/Einvoice/STATUS_CODE_NOT_GEN";
export const SELECTED_ROW = "boilerplate/NewEinv/Einvoice/SELECTED_ROW";
export const BUYER_GSTIN_LIST = "boilerplate/NewEinv/Einvoice/BUYER_GSTIN_LIST";
export const keyMap = {
  "0|AckDt|AckDt": "ack_dt",
  "0|AckNo|AckNo": "ack_no",
  "5|DocDtlsNo|Document_Num": "doc_no",
  "2|Irn|Irn": "irn",
  "0|is_error|is_error": "is_error",
  "0|status_cd|status_cd": "status_code",
  "0|SignedQRCode|SignedQRCode": "qr",
  txn_id: "txn_id",
};
